import React from 'react';
import { useFormContext } from "react-hook-form";
import { translate } from "../../Services/translation";
import StateField from "./StateField";
import InputField from "./InputField";
import CountryField from "./CountryField";
import DeliveryAddressField from "./DeliveryAddressField";
import constants from "../../constants";
import { useSelector } from 'react-redux';

const CustomerInformation = ({
                                 data,
                                 editable,
                                 isB2C
                             }) => {
    const checkout = useSelector((state) => state.checkout);
    const shouldLockEmailField = checkout.payload.lockEmailField;

    const { getValues, control } = useFormContext();

    const canEdit = editable;

    const { watch } = useFormContext();

    const paymentMethod = watch('paymentMethod');

    function getNonEditableText(key) {
        const text = getValues(key);

        if (!text) {
            return translate('checkout.forms.not-specified');
        }

        if (key.endsWith('.country')) {
            return constants.countries.find(x => x.value === text)?.text ?? text;
        }

        return text;
    }

    function isEditable(field) {
        if (!isB2C && field.name?.startsWith('billingAddress.') && paymentMethod === 'invoice') {
            return false;
        }

        return canEdit;
    }

    const keyMap = {
        state: StateField,
        country: CountryField,
        text: InputField,
        deliveryAddress: DeliveryAddressField
    };

    return (
        <div>
            <p className="checkout__form-group-title">{translate(data.title)}</p>
            <div className="checkout__form-group">
                {
                    data.fields.map((x, index) => {
                        if (x.type === 'empty') {
                            return <div></div>
                        }

                        const Component = keyMap[x.type]

                        let readOnly = x.name === 'customerDetails.email' && shouldLockEmailField;

                        return (
                            <div key={index}>
                                {
                                    isEditable(x) ?

                                        <Component
                                            name={x.name}
                                            control={control}
                                            label={x.label}
                                            prefix={data.key}
                                            field={x}
                                            readOnly={readOnly}
                                            {...x}
                                        />

                                        :
                                        <>
                                            {
                                                (x.type !== 'deliveryAddress' && x.type !== 'empty') && <>
                                                    <p className="checkout__label">{x.label}</p>
                                                    <p style={{ margin: 0 }}>{getNonEditableText(x.name)}</p></>
                                            }
                                        </>
                                }
                            </div>
                        )
                    })
                }
            </div>
        </div>
    );
};

export default CustomerInformation;
